module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"generate":"Generate","subtitle":"Subtitle"}}')
  delete Component.options._Ctor
}
